import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/navigation/Navbar';
import { usePlatformStore } from '../store/platformStore';
import { PageErrorBoundary } from '../components/common/ErrorBoundary';

const WorkbenchLayout: React.FC = () => {
  const { setActiveView } = usePlatformStore();
  const location = useLocation();

  useEffect(() => {
    setActiveView('Workbench');
  }, [location, setActiveView]);

  return (
    <div className="flex flex-col h-screen transition-colors duration-200 bg-theme-bg dark:bg-dark-theme-bg overflow-hidden">
      <Navbar activeTab="Workbench" />
      <div className="flex flex-1 min-h-0">
        <main className="flex-1 min-h-0">
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </main>
      </div>
    </div>
  );
};

export default WorkbenchLayout;